'use client';
import type { StaticImageData } from 'next/image';
import type { MissionsGroupVariants } from '../../../types';
import { useTranslations } from 'next-intl';
import Image from 'next/image';
import DAILY_MISSIONS_EMPTY from '@/public/assets/image/gamification/missions/daily-missions-empty@2x.webp';
import FAST_MISSIONS_EMPTY from '@/public/assets/image/gamification/missions/fast-missions-empty@2x.webp';
import COVER_EMPTY from '@/public/assets/image/gamification/missions/missions-empty-cover@2x.webp';
import WEEKLY_MISSIONS_EMPTY from '@/public/assets/image/gamification/missions/weekly-missions-empty@2x.webp';

interface Props {
  variant: MissionsGroupVariants;
}

const imgMap: Partial<Record<MissionsGroupVariants, StaticImageData>> = {
  daily: DAILY_MISSIONS_EMPTY,
  fast: FAST_MISSIONS_EMPTY,
  welcome: DAILY_MISSIONS_EMPTY,
  weekly: WEEKLY_MISSIONS_EMPTY,
};

export const MissionsGroupEmptyState = ({ variant }: Props) => {
  const t = useTranslations('gamification');

  const img = imgMap[variant]!;

  return (
    <div
      className={
        `flex h-20 lg:h-22 max-w-82 w-full px-4 py-[0.688rem] rounded-2xl glass-stroke-border
        justify-start pr-[7.188rem] overflow-hidden items-start flex-col gap-1 relative before:z-3!`
      }
    >
      <div className="gm-mission-empty-gradient" />
      <div
        style={{
          backgroundImage: `url(${COVER_EMPTY.src})`,
        }}
        className="absolute inset-0 -z-1 bg-no-repeat bg-cover"
      />
      <p className="text-lg font-medium leading-5.5 text-gradient bg-promo-banner-title-gradient">
        {t('mission-group.completed')}
      </p>
      <p className="text-xs font-medium leading-4 text-primary-3">
        {t(`mission-group.${variant}-missions.empty-title`)}
      </p>

      <Image
        src={img.src}
        alt={t(`mission-group.${variant}-missions.alt-empty`)}
        width={img.width}
        height={img.height}
        className="w-24.5 max-lg:top-1 h-20 lg:h-22 object-cover z-2 absolute top-0 right-0"
      />
    </div>
  );
};
